import { render, staticRenderFns } from "./DetailsFastener.vue?vue&type=template&id=60de6626&scoped=true&"
import script from "./DetailsFastener.vue?vue&type=script&lang=js&"
export * from "./DetailsFastener.vue?vue&type=script&lang=js&"
import style0 from "./DetailsFastener.vue?vue&type=style&index=0&id=60de6626&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60de6626",
  null
  
)

export default component.exports